import { CSSProperties, ReactNode, useRef } from 'react';
import { Portal } from 'react-portal';

interface ModalProps {
    show?: boolean;
    title?: string;
    onCloseButtonClick?: { (): void } | null;
    preventClosingAction?: { (): void } | boolean;
    titleClassName?: string | undefined;
    titleHeaderGrade?: number;
    wrapClassName?: string | null;
    width?: number | null;
    overwriteWidth?: boolean;
    closeOnEsc?: { (): void } | boolean;
    boldHeader?: boolean;
    overwriteOverflowX?: string;
    overwriteOverflowY?: string;
    wrapClassStyleForVideo?: {
        top: string;
        width: string;
        maxHeight: string;
        overflow: string;
    };
    isHeadlineHidden?: boolean;
    dlbStyle?: CSSProperties | undefined;
    children?: ReactNode;
    overflowX?: string;
    overflowY?: string;
    preventBodyScrolling?: boolean;
}

const ModalDialog = ({
    show = false,
    title = 'Headline',
    onCloseButtonClick = null,
    preventClosingAction = false,
    titleClassName = undefined,
    titleHeaderGrade = 4,
    wrapClassName = null,
    width = null,
    overwriteWidth = false,
    closeOnEsc = true,
    boldHeader = true,
    overwriteOverflowX,
    overwriteOverflowY,
    wrapClassStyleForVideo,
    isHeadlineHidden,
    dlbStyle,
    children
}: ModalProps) => {
    const wrapClasses = wrapClassName ? `dlb-wrap ${wrapClassName}` : 'dlb-wrap';
    const nonBreakingSpaceCharacter = '\u00A0';
    const headlineInner = boldHeader ? <b>{title}</b> : title;
    const content = title ? headlineInner : nonBreakingSpaceCharacter;
    const scrollInnerRef = useRef(null);

    let modalStyle: any = {};
    if (overwriteWidth) {
        modalStyle = {
            width: `${width}px`
        };
    }

    if (overwriteOverflowX) {
        modalStyle.overflowX = overwriteOverflowX;
    }

    if (overwriteOverflowY) {
        modalStyle.overflowY = overwriteOverflowY;
    }

    if (wrapClassStyleForVideo) {
        modalStyle = { ...wrapClassStyleForVideo, ...modalStyle };
    }

    const ModalTitle = `h${titleHeaderGrade}` as keyof JSX.IntrinsicElements;

    const headline = isHeadlineHidden ? null : (
        <div>
            {onCloseButtonClick ? (
                <a className="close" onClick={onCloseButtonClick}>
                    <i className="material-icons">clear</i>
                </a>
            ) : null}
            <ModalTitle className={titleClassName}>{content}</ModalTitle>
        </div>
    );

    return show ? (
        <Portal
            closeOnEsc={closeOnEsc}
            isOpened={show}
            onClose={!preventClosingAction && onCloseButtonClick ? onCloseButtonClick : () => {}}
        >
            <div>
                <div className="dlb-layer" />
                <div className={wrapClasses} style={modalStyle} ref={scrollInnerRef}>
                    <div className="dlb" style={dlbStyle} data-displayname="ModalDialog" data-testid="ModalDialog">
                        {headline}
                        {children}
                    </div>
                </div>
            </div>
        </Portal>
    ) : null;
};
export default ModalDialog;
